export default __webpack_public_path__ + "static/Entenda0049-c854aea19a2bcbcbaf4844d627b058e9.jpg";